export default "__VITE_ASSET__CGx1diWL__"